var ye = Object.defineProperty, _e = Object.defineProperties;
var be = Object.getOwnPropertyDescriptors;
var ae = Object.getOwnPropertySymbols;
var ke = Object.prototype.hasOwnProperty, Ce = Object.prototype.propertyIsEnumerable;
var se = (r, i, l) => i in r ? ye(r, i, { enumerable: !0, configurable: !0, writable: !0, value: l }) : r[i] = l, le = (r, i) => {
  for (var l in i || (i = {}))
    ke.call(i, l) && se(r, l, i[l]);
  if (ae)
    for (var l of ae(i))
      Ce.call(i, l) && se(r, l, i[l]);
  return r;
}, ie = (r, i) => _e(r, be(i));
var O = (r, i, l) => new Promise((g, B) => {
  var F = (v) => {
    try {
      C(l.next(v));
    } catch (h) {
      B(h);
    }
  }, E = (v) => {
    try {
      C(l.throw(v));
    } catch (h) {
      B(h);
    }
  }, C = (v) => v.done ? g(v.value) : Promise.resolve(v.value).then(F, E);
  C((l = l.apply(r, i)).next());
});
import { a as o, r as oe, u as z, q as Ne, B as he, m as R, o as we, b as xe, c as d, e as c, F as q, g as t, t as n, f, p as Se, n as ne, h as y, k as p, w as L, i as _ } from "./define-element-XpjsV6s1.js";
import { i as I } from "./utils-CMsllPx8.js";
import { u as Ve } from "./use-cart-D8NOb7eE.js";
import { u as Ae } from "./use-payment-CcwDaLQz.js";
import { I as T } from "./Input-yplyeePD.js";
import { T as Ue } from "./Textarea-DR6xAbu0.js";
import { B as re } from "./Button-D5lKR5Sd.js";
import { C as Pe } from "./CheckoutPayment-DikiEx66.js";
import { f as b } from "./format-currency-D_QngrXg.js";
import { _ as Re } from "./_plugin-vue_export-helper-CHgC5LLL.js";
const $ = o(!1), D = o(null);
function Le() {
  function r(i) {
    return O(this, null, function* () {
      var l;
      $.value = !0, D.value = null;
      try {
        yield oe("cart/config", {
          method: "PUT",
          body: JSON.stringify({
            gift_card_amount: i.gift_card_amount,
            recipient_first_name: i.recipient_first_name,
            recipient_last_name: i.recipient_last_name,
            recipient_email: i.recipient_email,
            recipient_message: i.recipient_message,
            insurance: 0
          })
        }), yield oe("addtocart/gift-card/1");
      } catch (g) {
        throw D.value = (l = g == null ? void 0 : g.message) != null ? l : "An error occurred", g;
      } finally {
        $.value = !1;
      }
    });
  }
  return { saveGiftCard: r, isSaving: $, error: D };
}
const Be = {
  class: "offset-gift-card-checkout",
  ref: "container"
}, Fe = {
  ref: "detailsHeading",
  tabindex: "-1",
  class: "offset-gift-card-section-title"
}, Ge = { class: "offset-gift-card-amount-section" }, Me = { class: "offset-gift-card-amount-display" }, Oe = { class: "offset-gift-card-presets" }, qe = ["aria-pressed", "onClick"], Te = ["aria-pressed"], Ee = {
  key: 0,
  class: "offset-gift-card-custom"
}, He = {
  key: 0,
  class: "error",
  role: "alert"
}, ze = { class: "offset-gift-card-custom-hint" }, Ie = { class: "offset-gift-card-recipient" }, $e = { class: "grouped" }, De = {
  key: 0,
  class: "error",
  role: "alert"
}, je = {
  key: 0,
  class: "error",
  role: "alert"
}, Ze = {
  key: 0,
  class: "error",
  role: "alert"
}, Je = { class: "offset-gift-card-checkout-layout" }, We = { class: "offset-gift-card-payment-col" }, Ke = {
  ref: "checkoutHeading",
  tabindex: "-1",
  class: "offset-gift-card-section-title"
}, Qe = {
  key: 0,
  class: "error offset-gift-card-checkout-error",
  role: "alert"
}, Xe = { class: "offset-gift-card-place-order" }, Ye = { class: "offset-gift-card-review-col" }, et = { class: "offset-gift-card-review-box" }, tt = { class: "offset-gift-card-review-table" }, at = { key: 0 }, st = { class: "offset-gift-card-message" }, lt = {
  __name: "GiftCardCheckout",
  props: {
    inheritStyle: {
      type: String,
      default: "all"
    },
    amount1: {
      type: String,
      default: "50"
    },
    amount2: {
      type: String,
      default: "100"
    },
    amount3: {
      type: String,
      default: "200"
    },
    min: {
      type: String,
      default: "25"
    },
    max: {
      type: String,
      default: "2500"
    }
  },
  emits: ["success"],
  setup(r, { emit: i }) {
    var te;
    const l = r, g = i, { saveGiftCard: B, isSaving: F } = Le(), { checkout: E, isCheckingOut: C } = Ve(), { selectedPayment: v } = Ae(), h = z("container"), w = o("details"), ue = z("detailsHeading"), de = z("checkoutHeading");
    Ne(w, (s) => {
      he(() => {
        var e;
        (e = s === "checkout" ? de.value : ue.value) == null || e.focus();
      });
    });
    const H = R(
      () => [l.amount1, l.amount2, l.amount3].map((s) => parseFloat(s)).filter((s) => !isNaN(s) && s > 0)
    ), G = R(() => parseFloat(l.min)), x = R(() => parseFloat(l.max)), N = o((te = H.value[0]) != null ? te : 50), m = o(!1), S = o(""), V = R(() => {
      if (m.value) {
        const s = parseFloat(S.value);
        return isNaN(s) ? 0 : Math.min(s, x.value);
      }
      return N.value;
    }), A = o(""), U = o(""), k = o(""), P = o(""), u = o({}), j = o(""), Z = o(""), J = o(""), W = o(""), K = o(""), Q = o(""), X = o(""), Y = o(""), ee = o(""), M = o(null), ce = R(() => !!v.value);
    function me(s) {
      N.value = s, m.value = !1, S.value = "", u.value = ie(le({}, u.value), { customAmount: null });
    }
    function fe() {
      var s;
      m.value = !m.value, m.value ? N.value = null : (N.value = (s = H.value[0]) != null ? s : 50, S.value = "");
    }
    function ve() {
      const s = {};
      if (I(A.value) && (s.firstName = "First name is required"), I(U.value) && (s.lastName = "Last name is required"), I(k.value) ? s.email = "Email is required" : /\S+@\S+\.\S+/.test(k.value) || (s.email = "Email address is not valid"), m.value) {
        const e = V.value;
        !e || e < G.value ? s.customAmount = `Minimum amount is ${b(G.value)}` : e > x.value && (s.customAmount = `Maximum amount is ${b(x.value)}`);
      }
      return u.value = s, Object.keys(s).length === 0;
    }
    function pe() {
      return O(this, null, function* () {
        if (ve())
          try {
            yield B({
              gift_card_amount: V.value,
              recipient_first_name: A.value,
              recipient_last_name: U.value,
              recipient_email: k.value,
              recipient_message: P.value
            }), w.value = "checkout";
          } catch (s) {
          }
      });
    }
    function ge() {
      return O(this, null, function* () {
        var s;
        M.value = null;
        try {
          const e = yield E({
            order_type: "Web",
            sales_agent: "Customer",
            shipping_exempt: 1
          });
          g("success", e);
        } catch (e) {
          M.value = (s = e == null ? void 0 : e.message) != null ? s : "An error occurred placing your order.";
        }
      });
    }
    return we(() => {
      xe(h.value, l.inheritStyle);
    }), (s, e) => (d(), c("div", Be, [
      w.value === "details" ? (d(), c(q, { key: 0 }, [
        t("h2", Fe, "Gift Card Details", 512),
        t("div", Ge, [
          t("div", Me, n(f(b)(V.value || 0)), 1),
          t("div", Oe, [
            (d(!0), c(q, null, Se(H.value, (a) => (d(), c("button", {
              key: a,
              type: "button",
              class: ne(["offset-gift-card-preset", !m.value && N.value === a ? "active" : ""]),
              "aria-pressed": !m.value && N.value === a,
              onClick: (it) => me(a)
            }, n(f(b)(a)), 11, qe))), 128)),
            t("button", {
              type: "button",
              class: ne(["offset-gift-card-preset", m.value ? "active" : ""]),
              "aria-pressed": m.value,
              onClick: fe
            }, " Custom ", 10, Te)
          ]),
          m.value ? (d(), c("div", Ee, [
            y(T, {
              type: "number",
              label: "Custom Amount",
              floating: !0,
              min: G.value,
              max: x.value,
              invalid: !!u.value.customAmount,
              modelValue: S.value,
              "onUpdate:modelValue": e[0] || (e[0] = (a) => S.value = a)
            }, null, 8, ["min", "max", "invalid", "modelValue"]),
            u.value.customAmount ? (d(), c("div", He, n(u.value.customAmount), 1)) : p("", !0),
            t("div", ze, " Must be between " + n(f(b)(G.value)) + " and " + n(f(b)(x.value)), 1)
          ])) : p("", !0)
        ]),
        e[15] || (e[15] = t("div", { class: "offset-gift-card-divider" }, null, -1)),
        t("div", Ie, [
          t("div", $e, [
            y(T, {
              type: "text",
              label: "Recipient's First Name",
              floating: !0,
              required: "",
              invalid: !!u.value.firstName,
              modelValue: A.value,
              "onUpdate:modelValue": e[1] || (e[1] = (a) => A.value = a)
            }, {
              default: L(() => [
                u.value.firstName ? (d(), c("div", De, n(u.value.firstName), 1)) : p("", !0)
              ]),
              _: 1
            }, 8, ["invalid", "modelValue"]),
            y(T, {
              type: "text",
              label: "Recipient's Last Name",
              floating: !0,
              required: "",
              invalid: !!u.value.lastName,
              modelValue: U.value,
              "onUpdate:modelValue": e[2] || (e[2] = (a) => U.value = a)
            }, {
              default: L(() => [
                u.value.lastName ? (d(), c("div", je, n(u.value.lastName), 1)) : p("", !0)
              ]),
              _: 1
            }, 8, ["invalid", "modelValue"])
          ]),
          y(T, {
            type: "text",
            label: "Recipient's Email",
            floating: !0,
            required: "",
            autocorrect: "off",
            autocapitalize: "off",
            invalid: !!u.value.email,
            modelValue: k.value,
            "onUpdate:modelValue": e[3] || (e[3] = (a) => k.value = a)
          }, {
            default: L(() => [
              u.value.email ? (d(), c("div", Ze, n(u.value.email), 1)) : p("", !0)
            ]),
            _: 1
          }, 8, ["invalid", "modelValue"]),
          y(Ue, {
            label: "Gift Message",
            floating: !0,
            rows: "5",
            placeholder: "Enjoy this gift card!",
            modelValue: P.value,
            "onUpdate:modelValue": e[4] || (e[4] = (a) => P.value = a)
          }, null, 8, ["modelValue"])
        ]),
        y(re, {
          onClick: pe,
          disabled: f(F)
        }, {
          default: L(() => [
            _(n(f(F) ? "Saving..." : "Next"), 1)
          ]),
          _: 1
        }, 8, ["disabled"])
      ], 64)) : w.value === "checkout" ? (d(), c(q, { key: 1 }, [
        t("button", {
          class: "offset-gift-card-back",
          type: "button",
          onClick: e[5] || (e[5] = (a) => w.value = "details")
        }, e[16] || (e[16] = [
          t("svg", {
            width: "20",
            height: "20",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
          }, [
            t("path", {
              d: "M8.288 12L14.298 18.01L15.712 16.596L11.112 11.996L15.712 7.396L14.298 5.99L8.288 12Z",
              fill: "currentColor"
            })
          ], -1),
          _(" Return to Gift Card Details ", -1)
        ])),
        t("div", Je, [
          t("div", We, [
            t("h2", Ke, "Payment Method", 512),
            y(Pe, {
              inheritStyle: l.inheritStyle,
              first_name: j.value,
              "onUpdate:first_name": e[6] || (e[6] = (a) => j.value = a),
              last_name: Z.value,
              "onUpdate:last_name": e[7] || (e[7] = (a) => Z.value = a),
              address: J.value,
              "onUpdate:address": e[8] || (e[8] = (a) => J.value = a),
              address_2: W.value,
              "onUpdate:address_2": e[9] || (e[9] = (a) => W.value = a),
              city: K.value,
              "onUpdate:city": e[10] || (e[10] = (a) => K.value = a),
              state: Q.value,
              "onUpdate:state": e[11] || (e[11] = (a) => Q.value = a),
              zip: X.value,
              "onUpdate:zip": e[12] || (e[12] = (a) => X.value = a),
              country: Y.value,
              "onUpdate:country": e[13] || (e[13] = (a) => Y.value = a),
              businessName: ee.value,
              "onUpdate:businessName": e[14] || (e[14] = (a) => ee.value = a)
            }, null, 8, ["inheritStyle", "first_name", "last_name", "address", "address_2", "city", "state", "zip", "country", "businessName"]),
            M.value ? (d(), c("div", Qe, n(M.value), 1)) : p("", !0),
            t("div", Xe, [
              y(re, {
                onClick: ge,
                disabled: !ce.value || f(C)
              }, {
                default: L(() => [
                  _(n(f(C) ? "Placing Order..." : `Place Order — ${f(b)(V.value)}`), 1)
                ]),
                _: 1
              }, 8, ["disabled"]),
              e[17] || (e[17] = t("p", { class: "offset-gift-card-terms" }, [
                _(" By placing your order you agree to our "),
                t("a", { href: "/terms/" }, "Terms & Conditions"),
                _(" and "),
                t("a", { href: "/privacy/" }, "Privacy Policy"),
                _(". ")
              ], -1))
            ])
          ]),
          t("div", Ye, [
            e[22] || (e[22] = t("h2", { class: "offset-gift-card-section-title" }, "Order Review", -1)),
            t("div", et, [
              t("table", tt, [
                t("tbody", null, [
                  t("tr", null, [
                    e[19] || (e[19] = t("td", null, "Recipient", -1)),
                    t("td", null, [
                      _(n(A.value) + " " + n(U.value) + " ", 1),
                      k.value ? (d(), c(q, { key: 0 }, [
                        e[18] || (e[18] = t("br", null, null, -1)),
                        _(n(k.value), 1)
                      ], 64)) : p("", !0)
                    ])
                  ]),
                  P.value ? (d(), c("tr", at, [
                    e[20] || (e[20] = t("td", null, "Message", -1)),
                    t("td", st, n(P.value), 1)
                  ])) : p("", !0),
                  t("tr", null, [
                    e[21] || (e[21] = t("td", null, [
                      t("strong", null, "Order Total")
                    ], -1)),
                    t("td", null, [
                      t("strong", null, n(f(b)(V.value)), 1)
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ], 64)) : p("", !0)
    ], 512));
  }
}, yt = /* @__PURE__ */ Re(lt, [["__scopeId", "data-v-8078751f"]]);
export {
  yt as G
};
